<template>
  <v-tooltip bottom color="white">
    <template v-slot:activator="{ on }">
      <v-icon
        v-if="row.propsStructure.compounded"
        left
        v-on="on"
        @click="() => compoundedChanged(false)"
        color="success"
      >
        mdi-checkbox-marked-circle
      </v-icon>
      <v-icon v-else @click="() => compoundedChanged(true)" v-on="on" left>
        mdi-close
      </v-icon>
    </template>
    <span v-if="row.propsStructure.compounded" class="black--text">
      This is a compounded drug. Click to mark as
      <strong>Not compounded</strong>
    </span>
    <span v-else class="black--text">
      This is Not compounded drug. Click to mark as
      <strong>compounded</strong>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => ({
        propsStructure: {
          computed: false
        }
      })
    }
  },
  methods: {
    compoundedChanged(value) {
      this.$emit('onCompoundedChanged', {
        id: this.row.propsStructure.id,
        compounded: value
      });
    }
  }
};
</script>
